import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import InputLanguageSelect from "components/ProjectNonSpecificComponents/Elements/InputLanguageSelect"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { lostOrFinishedAdminSession } from "components/ProjectSpecificComponents/API/Functions/lostOrFinishedAdminSession"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import UserFormWelcomeText from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/Forms/UserFormWelcomeText"
import {
	IAdditional,
	ISettings,
} from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { observe } from "mobx"
import { observer } from "mobx-react-lite"
import React, { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import PreferencesSmallButton from "../../atoms/Buttons/PreferencesSmallButton"
import CookieBarConfig from "./CookieBarConfig"
import SubmitTextConfiguration from "./SubmitTextConfiguration"
import ToolTipConfiguration from "./ToolTipConfiguration"

const AdditionalSettings = observer(() => {
	const formStore = useFormStore()
	const store = useStore()
	const history = useHistory()
	const { t } = useTranslation()
	const { isMobile } = useScreenType()

	const saveAdditionalFields = async () => {
		const { ok, data, statusCode } = await AppRequests("Setting").post<
			Partial<IAdditional>,
			ISettings
		>("save-additional-field", formStore.settingsData.additionalInfo)

		if (ok && data) {
			formStore.mergeSettingsDataSafely(data)
			store.setInfoModalConfig({
				type: "info",
				titleKey: "data-saving.additional-success",
				showDuration: 1000,
			})
		} else if (statusCode == 401) {
			lostOrFinishedAdminSession(history, store)
		} else {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "data-saving.failed",
			})
		}
	}

	return (
		<HyperDiv direction="column" width="100%">
			<HyperDiv direction="row" padding="8px 16px" spaceBetweenElems=".625rem">
				<HyperDiv
					centeredY
					style={{
						fontSize: isMobile ? 16 : 14,
						whiteSpace: "normal",
					}}
					children={t("forms.field-label.settings-language")}
				/>
				<InputLanguageSelect type={"settingsLanguage"} />
			</HyperDiv>

			<Whitespace h x="1" />

			{/* Welcome text in user side */}
			<UserFormWelcomeText />
			<hr />
			
			{/* For all tooltips */}
			<ToolTipConfiguration />
			<hr />
            
			<SubmitTextConfiguration />
			<hr />
            
			<CookieBarConfig />

			<HyperDiv centered margin=".5rem">
				<PreferencesSmallButton
					style={{ width: "25%" }}
					onClick={() => saveAdditionalFields()}
					children={t("rawText.save")}
				/>
			</HyperDiv>
		</HyperDiv>
	)
})

export default AdditionalSettings
